import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BaseFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { ShFieldLabelComponent } from '../../../../../form-controls/components/_core/field-label/field-label.component';
import { SimpleFieldValue } from '../../../../entities/field-values/field-type-values.entity';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-time-code-readonly-field',
    templateUrl: '../simple-readonly-field/simple-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShTimeCodeReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: SimpleFieldValue = this.fieldHelper.getTimeCodeFieldValue(
            profileField.FieldDefinition as BaseFieldDefinition,
            record
        );
        this.value$.next(value);
    }
}
